// initial state
import * as base from './base.js'
const baseName = '/admin/api/skill'
const baseCategoryName = '/admin/api/skill_category'
const skillbaseCategory = '/admin/api/skill_category/lists'

const obj = base.setBaseUrl('skill', baseName)
const obj1 = base.setBaseUrl('skill_category', baseCategoryName)

const a = Object.assign(obj,obj1, {skillbaseCategory})
export default a
